module.exports = __webpack_public_path__ + "static/img/wmp869.3c6290c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/wmp869.jpg
// module id = 6wKI
// module chunks = 0